var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{attrs:{"icon":"","tooltip":_vm.$t('common.changeTheme')},on:{"click":function($event){_vm.$vuetify.theme.dark = !_vm.$vuetify.theme.dark}}},[_c('v-icon',[_vm._v("mdi-theme-light-dark")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }